import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { RoomTypeContainer } from '../../containers/filters/RoomTypeContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const roomType: IOpenableFilter = {
  availability: ({ jsonQuery }) => isAvailable(FDealType.Any, FOfferType.Flat)(jsonQuery),
  component: RoomTypeContainer,
  type: EFilterType.Openable,
};
